import request from '../request';
import { objectToQueryString } from '../../components/Dashboard/DataEntry/helpers/objectToQueryString';

export const getTemplates = (skip = 0, limit = 50, filter, type = 'assessment', active = true) =>
  request
    .get(
      `/data-entry/templates?type=${type}&skip=${skip}&limit=${limit}&active=${active}&${objectToQueryString(
        filter
      )}`
    )
    .then((res) => res);

export const getTemplate = (templateId = '') =>
  request.get(`/data-entry/templates/${templateId}`).then((res) => res);

export const deleteTemplate = (templateId = '') =>
  request.delete(`/data-entry/templates/${templateId}`).then((res) => res);

export const createTemplate = (data = {}) => request.post(`/data-entry/templates`, data).then((res) => res);

export const cloneTemplate = (templateId = '', data = {}) =>
  request.post(`/data-entry/templates/${templateId}/clone`, data).then((res) => res);

export const importTemplates = (data = {}, type = '') =>
  request.post(`/data-entry/templates/import/${type}`, data).then((res) => res);

export const exportTemplates = (data = [], type = '') =>
  request.post(`/data-entry/templates/export/${type}`, data, {
    responseType: 'blob'
  });

export const updateTemplateData = (templateId = '', data = {}) =>
  request.put(`/data-entry/templates/${templateId}`, data).then((res) => res);

export const isTemplateTaken = (templateType = '', name = '', templateId = '') =>
  request
    .get(
      `/data-entry/templates/check-name/${templateType}/${name}${
        templateId ? `?templateId=${templateId}` : ''
      }`
    )
    .then((res) => res);

export const areTemplateNamesTaken = (templateType = '', names = []) =>
  request
    .get(`/data-entry/templates/check-names/${templateType}?${objectToQueryString({ names })}`)
    .then((res) => res);

export const getAnswerOptionsLibrary = (templateType = 'surveys') =>
  request.get(`/data-entry/answer-options-library/${templateType}`).then((res) => res);
